import { forwardRef, HtmlHTMLAttributes, memo, ReactNode } from "react";
import classNames from "classnames";
import { AdditionalActionDescription, AdditionalActions } from "../AdditionalActions";

import styles from "./styles.module.scss";

export type SectionHeaderPropsType = Omit<HtmlHTMLAttributes<HTMLDivElement>, "children"> & {
  tabs?: ReactNode
  header?: string
  actions?: ReactNode | ReactNode[]
  divider?: boolean
  supportingText?: string
  additionalActions?: AdditionalActionDescription[],
}

export const SectionHeader = memo(forwardRef<HTMLDivElement, SectionHeaderPropsType>((
  {
    tabs,
    header,
    actions,
    divider,
    className,
    supportingText,
    additionalActions,
    ...props
  }, ref) => {

  const withAdditionalActions = !!additionalActions?.length;

  return (
    <div
      {...props}
      ref={ref}
      className={classNames(
        className,
        styles.root,
        {
          [styles.divider]: divider,
          [styles.withAdditionalActions]: withAdditionalActions,
        },
      )}
    >
      <div className={styles.textBlock}>
        <h2 className={styles.headerText}>{header}</h2>
        {supportingText && <p className={styles.supportingText}>{supportingText}</p>}
      </div>
      <div className={styles.actions}>
        {actions}
      </div>
      {
        withAdditionalActions &&
        <AdditionalActions
          key="additionalActions"
          buttonProps={{
            className: styles.additionalActions
          }}
          actions={additionalActions}
        />
      }
      {tabs && <div className={styles.tabs}>{tabs}</div>}
    </div>
  );
}));
